<script>
import { isBefore, isWithinInterval, parseISO, addMonths } from 'date-fns';
import { mapGetters } from 'vuex';
export default {
  name: 'CardsListItemLigneCommande',
  props: {
    ligne: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      contrats: 'contrats/contrats'
    }),
    numContrat () {
      return this.contrats
        .filter(c => c.numArticle === this.ligne.numArticle)
        .filter(c => isWithinInterval(Date.now(), { start: parseISO(c.dateDebut), end: parseISO(c.dateFin) }))
        .map(c => c.numContrat)
        .shift();
    },
    alerteContrat () {
      const contratsAlerte = this.contrats
        .filter(c => c.numArticle === this.ligne.numArticle)
        .filter(c => isBefore(parseISO(c.dateFin), addMonths(Date.now(), 1)) && c.qteRestante > 0);

      return contratsAlerte.length > 0;
    }
  }
};
</script>
<template>
  <div class="list-ligne">
    <div class="list-ligne-content">
      <div>
        <strong>{{ ligne.libelleArticle }}</strong><sub class="num-article">{{ ligne.numArticle }}</sub>
      </div>

      <div class="no-wrap primary--text">
        <div
          v-if="ligne.codeUniteArticle === 'T'"
          class="v-center"
        >
          <v-icon color="primary">
            mdi-weight
          </v-icon>
          {{ ligne.quantiteCommande | formatDecimal(3) }} t
        </div>
        <div v-else>
          {{ ligne.quantiteCommande }}
        </div>
      </div>
      <div class="actions-container">
        <slot
          name="actions"
          :ligne="ligne"
        />
      </div>
    </div>

    <div class="suppl secondary--text">
      <div v-if="ligne.supplementations">
        <div
          v-for="(supp, index) in ligne.supplementations"
          :key="index"
        >
          {{ supp.libelleArticle }}
        </div>
      </div>
      <div v-if="ligne.mineraux">
        <div
          v-for="(mineral, index) in ligne.mineraux"
          :key="index"
        >
          {{ mineral.libelleArticle }} {{ mineral.quantiteCommande }} %
        </div>
      </div>
    </div>

    <div
      v-if="numContrat"
      class="no-wrap"
    >
      <span class="secondary--text">Contrat : {{ numContrat }}</span>
      <v-tooltip
        v-if="alerteContrat"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            color="warning"
            class="ml-1"
            v-on="on"
          >
            mdi-alert-circle
          </v-icon>
        </template>
        <span>Le contrat est non soldé et expire dans moins d'un mois.</span>
      </v-tooltip>
    </div>
    <div class="stockage">
      <div v-if="ligne.numBatiment">
        Bâtiment {{ ligne.numBatiment }}
      </div>
      <div
        style="flex-wrap:wrap;"
        class="infos-lieu-container primary--text v-center"
      >
        <v-icon color="primary">
          mdi-home
        </v-icon>
        <span
          v-if="ligne.codeTypeSilo1"
          class="avoidwrap"
        >
          <RefValue
            :code="ligne.codeTypeSilo1"
            type="TYPE_SILO"
          />
        </span>
        <span
          v-if="ligne.codeTypeSilo2"
          class="avoidwrap"
        >
          <RefValue
            :code="ligne.codeTypeSilo2"
            type="TYPE_SILO"
          />
        </span>
        <span
          v-if="ligne.codeTypeSilo3"
          class="avoidwrap"
        >
          <RefValue
            :code="ligne.codeTypeSilo3"
            type="TYPE_SILO"
          />
        </span>
      </div>
    </div>
    <div class="infos">
      <slot
        name="infos"
        :ligne="ligne"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list-ligne {
  padding: 0.5em 1em;
}
.list-ligne-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
  & > *:first-child {
    flex-grow: 1;
  }
  & > *:not(:first-child) {
    margin-left: 1em;
  }
}

.infos-lieu-container {
  span {
    margin-right: 0.58em;
    vertical-align: sub;
  }
}

.infos {
  font-style: italic;
  font-size: 0.9em;
}
</style>
